/* eslint-disable react/jsx-no-literals */
import React from 'react';

import type { PatientRecords } from '@hooks/api/patient-record';

import { MainContainer } from '@layouts/Layouts/TableLayout';

import Contacts from '@views/HealthSummary/Contacts';
import { CardWrapper } from '@views/HealthSummary/Main/Main.style';
import InsuranceSection from '@views/HealthSummary/Summary/InsuranceSection';
import ProfileCard from '@views/HealthSummary/Summary/ProfileCard/ProfileCard';

import Directives from '../HealthSummary/Directives';
import Summary from '../HealthSummary/Summary';
import { FullWrapper } from './EmergencyData.style';

interface EmergencyDataPageProps {
  records?: PatientRecords;
  loading?: boolean;
}

function EmergencyDataPage({
  records,
  loading = false,
}: EmergencyDataPageProps) {
  const patient = records?.patient;

  return (
    <MainContainer>
      <FullWrapper>
        {records?.patient ? (
          <ProfileCard loading={loading} patient={patient} />
        ) : null}
        <InsuranceSection coverage={records?.coverage} loading={loading} />
        <Summary clickable={false} loading={loading} {...records} />
        <CardWrapper>
          <Directives clickable={false} loading={loading} {...records} />
          <Contacts clickable={false} loading={loading} {...records} />
        </CardWrapper>
      </FullWrapper>
    </MainContainer>
  );
}

export default EmergencyDataPage;
